import React from 'react';

import * as styles from './index.module.scss';

const PageContentContainerWide = ({children, hasMargin, isSlim = false}) => (
    <div className={`${styles.pageContentWrapWide} ${hasMargin ? styles.pageContentWrapWideWithMargin : null} ${isSlim ? styles.pageContentWrapWideSlim : null}`}>
        {children}
    </div>
)

export default PageContentContainerWide;